import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addPost } from '../../actions/post';

const PostForm = ({ addPost, auth: { user } }) => {
  const [text, setText] = useState('');

  return (
    <div className="post-form-container card rounded-0 mb-3">
      <div className="bg-light py-1">
        <p className="px-2 text-dark create-post d-inline">Create Post</p>
        <a
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          className="float-right text-secondary pr-3"
        >
          <i className="fas fa-info-circle create-post rounded-circle shadow-sm"></i>
        </a>
      </div>
      <hr className="my-0" />
      {/* <form
        className="pb-1"
        onSubmit={(e) => {
          e.preventDefault();
          addPost({ text });
          setText('');
        }}
      >
        <div className="card-body pt-2 pb-1 px-2">
          <div className="form-group row my-0">
            <label
              htmlFor="new-post-text"
              className="col-2 col-sm-1 col-form-label pr-2 pt-1"
            >
              <img
                src={user.avatar}
                className="rounded-circle post-profile-pic"
                alt=""
              />
            </label>
            <div className="col-8 col-sm-9 ml-0 ml-sm-1 pl-0 pl-md-2 pr-3">
              <textarea
                className="form-control border-0 shadow-sm"
                id="new-post-text"
                placeholder="What's on your mind?"
                rows="2"
                value={text}
                onChange={(e) => setText(e.target.value)}
                required
              ></textarea>
            </div>
            <div className="col-1 align-self-end mx-auto px-0">
              <button
                className="btn btn-light py-1 px-2 px-xl-3 float-right"
                type=""
                value="Submit"
              >
                Post
              </button>
            </div>
          </div>
        </div>
      </form> */}

      <form
        className="post-form"
        onSubmit={(e) => {
          e.preventDefault();
          addPost({ text });
          setText('');
        }}
      >
        <div className="card-body pt-2 pb-1 px-2">
          <div className="post-form-inputs">
            <label htmlFor="new-post-text" className="">
              <img src={user.avatar} className="post-profile-pic" alt="" />
            </label>
            <div className="post-form-text-container col-sm-9">
              <textarea
                className="form-control"
                id="new-post-text"
                placeholder="What's on your mind?"
                rows="2"
                value={text}
                onChange={(e) => setText(e.target.value)}
                required
              ></textarea>
            </div>
            <div className="send-post-container">
              <button className="btn secondary-btn" type="" value="Submit">
                Post
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

PostForm.propTypes = {
  addPost: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { addPost })(PostForm);
